export default () => ({
  vehicles: [],
  vehicle: null
})
